import React, { useEffect, useState } from "react";
import Table from "../../Components/shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchFormData, formatDateOnly } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const RoleTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [roleData, setRoleData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

 const fetchRoleData = async () => {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    const result = await fetchFormData("role/list", formData, "POST");

    if (result) {
      const user = result.data || [];

      const sortedRoles = user.sort((a, b) =>
        a.role.localeCompare(b.role, undefined, { sensitivity: "base" })
      );
      setRoleData(sortedRoles);
    }

    Swal.close();
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    const result = await fetchFormData(
      `role/toggle-status/${Id}`,
      formData,
      "POST"
    );

    if (result && result.code === 200) {
     await fetchRoleData();
      if (result && result.user.status === 1) {
        topTost({
          title: "Status updated successfully : Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully : Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle status:", result.message);
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <FiEdit3
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/master/edit-role/${id}?id=${M_id}`)
                      }
                    />
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === "1" ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),

    {
      accessorKey: "role",
      header: () => "Role",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    // {
    //   accessorKey: "branch_name",
    //   header: () => "Branch Name",
    //   cell: (info) => info.getValue(),
    //   defaultIsVisible: true,
    // },
    // {
    //   accessorKey: "branchID",
    //   header: () => "Branch ID",
    //   cell: (info) => info.getValue(),
    //   defaultIsVisible: true,
    // },
    {
      accessorKey: "name",
      header: () => "Created By",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "created_at",
      header: () => "Created At",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },

    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue();
        const label = val === "1" ? "Active" : "Deactive";
        const styles = {
          backgroundColor: val === "1" ? "#cce5ff" : "#fff3cd", // Sky blue / Light yellow
          color: val === "1" ? "#004085" : "#856404", // Dark blue / Dark yellow
          padding: "4px 10px",

          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchRoleData();
  }, []);
  return (
    <>
      <Table data={roleData} columns={columns} />
    </>
  );
};

export default RoleTable;
